import { genericTableDataActions } from '@app/shared/table/helpers/generic-table-actions';
import { on } from '@ngrx/store';
import { TableDataState } from '@app/shared/table/helpers/generic-table-state';
import { initialPagedData } from '@app/core/models/PagedApiData';

export const dataTablesReducers = <T extends TableDataState>(
  actionPrefix: string,
  ...indexes: string[]
) =>
  indexes
    .map((index) => [
      on(
        genericTableDataActions(actionPrefix).loadTableData(index),
        (
          state: T,
          { index, limit, offset, sort, searchData, complexSearchData },
        ) => ({
          ...state,
          dataTables: state.dataTables.set(index, {
            ...state.dataTables.get(index),
            isLoading: true,
            limit,
            offset,
            sort,
            complexSearchData,
            searchData,
          }),
        }),
      ),
      on(
        genericTableDataActions(actionPrefix).loadTableDataSuccess(index),
        (state: T, { index, response }) => ({
          ...state,
          dataTables: state.dataTables.set(index, {
            ...state.dataTables.get(index),
            data: [...state.dataTables.get(index).data, ...response.data],
            total: response.total,
            totalPages: response.totalPages,
            currentPage: response.currentPage,
            isLoading: false,
          }),
        }),
      ),
      on(
        genericTableDataActions(actionPrefix).loadTableDataFailure(index),
        (state: T, { index, error }) => ({
          ...state,
          dataTables: state.dataTables.set(index, {
            ...state.dataTables.get(index),
            data: [],
            isLoading: false,
            error,
          }),
        }),
      ),
      on(
        genericTableDataActions(actionPrefix).clearTableData(index),
        (state: T, { index, maintainFilters }) => ({
          ...state,
          dataTables: state.dataTables.set(
            index,
            maintainFilters
              ? {
                  ...initialPagedData,
                  searchData: state.dataTables.get(index).searchData,
                }
              : initialPagedData,
          ),
        }),
      ),
      on(
        genericTableDataActions(actionPrefix).updateRowData(index),
        (state: T, { index, rowIdColumnName, rowIdValue, updates }) => ({
          ...state,
          dataTables: state.dataTables.set(index, {
            ...state.dataTables.get(index),
            data: [
              ...state.dataTables.get(index).data.map((rowData) =>
                rowData[rowIdColumnName] === rowIdValue
                  ? {
                      ...rowData,
                      ...Object.assign({}, ...updates),
                    }
                  : rowData,
              ),
            ],
          }),
        }),
      ),
    ])
    .reduce((accumulator, value) => accumulator.concat(value), [])
    .map((x) => x as any);
